import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const Value = styled.span`
  text-align: end;
`;

type ProductSizeProps = {
  size?: string;
};

export const ProductSize: React.FC<ProductSizeProps> = ({ size }) => {
  const { formatMessage } = useIntl();

  if (!size || !size.length) {
    return null;
  }

  const title = formatMessage({ id: 'productSizeTitle' });

  return (
    <Container data-testid="product-size">
      <span>{title}</span>
      <Value>{size}</Value>
    </Container>
  );
};
